export const en = {
  actionCard: {
    titles: {
      upcoming_event: 'Upcoming Event',
      unpublished_event: 'Incomplete Draft',
      pending_feedback: 'Feedback Required',
      upcoming_created_event: 'Upcoming Created Event',
      upcoming_requested_event: 'Upcoming Requested Event',
      pending_approval: 'Approval Needed'
    },
    descriptions: {
      upcoming_event: '{{eventName}} on {{date}}',
      unpublished_event: 'Finish creating your event',
      pending_feedback: 'Submit feedback for {{eventName}}',
      upcoming_created_event: '{{eventName}} on {{date}}',
      upcoming_requested_event: '{{eventName}} on {{date}}',
      pending_approval: '{{name}} would like to join {{eventName}}',
      pending_approval_plural: '{{name}} +{{others}} more would like to join {{eventName}}'
    },
    notifications: {
      header: 'Notifications',
      view_all: 'View All',
      hide_all: 'Hide All',
      empty_state: 'No new notifications',
      mark_as_read: 'Mark all read',
    }
  }
}